import { PayloadAction } from "@reduxjs/toolkit";
import { apiCall } from "../../utils/apiCall";
import { put, all, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";
import { cargaActions } from "./reducer";
import { formatError } from "../../utils/formatError";
import { store } from "../app/mainReducer";
import { requestEnviaGestaoEntregaWorker } from "../entrega/saga";
import { getQuestionarioSatisfacaoCodigo } from "../../utils/questionarioSatisfacaoRegras";

export const getGestaoEntregaPendentes = () => store.getState().entrega.gestao_entrega_pendentes;

function questionarioCodigoQuery(): string {
  const questionarioCodigo = getQuestionarioSatisfacaoCodigo();
  return questionarioCodigo
    ? `?questionario_codigo=${encodeURIComponent(questionarioCodigo)}`
    : "";
}

function* cargasWorker() {
  try {
    const gestao_entrega_pendentes = getGestaoEntregaPendentes();

    if (gestao_entrega_pendentes) {
      for (const gestao of gestao_entrega_pendentes) {
        if (gestao) {
          yield call(requestEnviaGestaoEntregaWorker, { payload: gestao, type: 'entrega/requestEnviaGestaoEntrega' });
        }
      }
    }

    const res: AxiosResponse<any> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/cargas${questionarioCodigoQuery()}`,
      method: "get",
    });
    yield put(cargaActions.cargasRequestSuccess(res.data));
  } catch (error) {
    yield put(
      cargaActions.cargasError(formatError(error))
    );
  }
}

function* cargaWorker({ payload }: PayloadAction<{ ukey: string }>) {
  try {
    const res: AxiosResponse<any> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/cargas/${payload.ukey}${questionarioCodigoQuery()}`,
      method: "get",
    });
    yield put(cargaActions.cargaRequestSuccess(res.data));
  } catch (error) {
    yield put(
      cargaActions.cargasError(formatError(error))
    );
  }
}


function* cargaAgrupamentoRequestWorker({ payload }: PayloadAction<{ ukey: string; codigo_agrupamento: string; }>) {
  try {
    const res: AxiosResponse<any> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/cargas/${payload.ukey}/agrupamento/${payload.codigo_agrupamento}${questionarioCodigoQuery()}`,
      method: "get",
    });
    yield put(cargaActions.cargaAgrupamentoRequestSuccess(res.data));
  } catch (error) {
    yield put(
      cargaActions.cargasError(formatError(error))
    );
  }
}

function* cargasFinalizadasWorker({ payload }: PayloadAction<{ page?: number }>) {
  try {
    const page = payload?.page || 1;
    const res: AxiosResponse<any> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/cargas-finalizadas`,
      method: "get",
      params: {
        page,
      },
    });
    yield put(cargaActions.cargasFinalizadasRequestSuccess({
      data: res.data.data || res.data,
      current_page: res.data.current_page || page,
      last_page: res.data.last_page || 1,
    }));
  } catch (error) {
    yield put(
      cargaActions.cargasFinalizadasError(formatError(error))
    );
  }
}

export function* cargaSaga() {
  yield all([
    takeLatest("carga/cargasRequest", cargasWorker),
    takeLatest("carga/cargaRequest", cargaWorker),
    takeLatest("carga/cargaAgrupamentoRequest", cargaAgrupamentoRequestWorker),
    takeLatest("carga/cargasFinalizadasRequest", cargasFinalizadasWorker),
  ]);
}
